var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFreeMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2429 4.75708C17.586 7.10023 17.586 10.8992 15.2429 13.2424M6.75758 13.2424C4.41443 10.8992 4.41443 7.10023 6.75758 4.75708M3.92893 16.0708C0.0236893 12.1656 0.0236893 5.83395 3.92893 1.92871M18.0715 1.92871C21.9768 5.83395 21.9768 12.1656 18.0715 16.0708M11.0002 10.9998C12.1048 10.9998 13.0002 10.1043 13.0002 8.99976C13.0002 7.89519 12.1048 6.99976 11.0002 6.99976C9.89565 6.99976 9.00022 7.89519 9.00022 8.99976C9.00022 10.1043 9.89565 10.9998 11.0002 10.9998ZM11.0002 10.9998V19.9998",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeMode);
export default __webpack_public_path__ + "static/media/FreeMode.755e321e377fcd182c4d1f8a524cb7f7.svg";
export { ForwardRef as ReactComponent };